import { DiscoveryApi, FetchApi } from '@backstage/core-plugin-api';
import { ContributeApi, GitlabLookupResult } from './contributeTypes';

const DEFAULT_TIMEOUT_MS = 10_000;

export class ContributeClient implements ContributeApi {
  constructor(
    private readonly options: {
      discoveryApi: DiscoveryApi;
      fetchApi: FetchApi;
      timeoutMs?: number;
    },
  ) {}

  // Never throws: "not found" blocks the form, anything else (5xx, network,
  // timeout) lets it open without prefill, as the design requires.
  async lookupGitlabProject(
    host: string,
    projectPath: string,
  ): Promise<GitlabLookupResult> {
    const baseUrl = await this.options.discoveryApi.getBaseUrl('tech-talk');
    const query = new URLSearchParams({ host, path: projectPath });
    const controller = new AbortController();
    const timer = setTimeout(
      () => controller.abort(),
      this.options.timeoutMs ?? DEFAULT_TIMEOUT_MS,
    );
    try {
      const response = await this.options.fetchApi.fetch(
        `${baseUrl}/gitlab-project?${query}`,
        { signal: controller.signal },
      );
      if (response.status === 404) {
        return { status: 'not-found' };
      }
      if (!response.ok) {
        return { status: 'unavailable' };
      }
      return { status: 'found', project: await response.json() };
    } catch {
      return { status: 'unavailable' };
    } finally {
      clearTimeout(timer);
    }
  }
}
